import { Observable, Subject } from 'rxjs';

import { Injectable, EventEmitter } from '@angular/core';

import { FsPanorama } from '@lib/api/entities';

@Injectable({ providedIn: 'root' })
export class SnLocationView {
  public activeCamera$ = new EventEmitter<string>();
  public activePanoramas$ = new EventEmitter<string>();
  public listCameraActive = [];
  public listOfActivePanoramas = [];

  private readonly _activePanorama$ = new Subject<FsPanorama>();

  constructor() {}

  get activePanorama$(): Observable<FsPanorama> {
    return this._activePanorama$.asObservable();
  }

  public setCurrentActiveCamera(id: string): void {
    this.listCameraActive.push(id);
    this.activeCamera$.next();
  }

  public setActivePanorama(id: string): void {
    this.listOfActivePanoramas.push(id);
    this.activePanoramas$.next();
  }

  public removeActiveCamera(id: string): void {
    this.listCameraActive.splice(this.listCameraActive.indexOf(id), 1);
    this.activeCamera$.next();
  }

  public removeActivePanorama(id: string): void {
    this.listOfActivePanoramas.splice(this.listOfActivePanoramas.indexOf(id), 1);
    this.activePanoramas$.next();
  }

  public activatePanorama(panorama: FsPanorama): void {
    this._activePanorama$.next(panorama);
  }
}
